import { tr as t } from "@/lib/i18n";

const split = (v) => {
  const [a, ...rest] = (v || "").split("/");
  return rest.length ? [a, rest.join("")] : ["", a];
};

export default function CarPlateInput({ value, onChange, testid = "car-plate", optional }) {
  const [adm, plate] = split(value);
  const upd = (a, p) => onChange(a || p ? `${a}/${p}` : "");
  return (
    <div className="flex gap-2 items-center" dir="rtl">
      <input data-testid={`${testid}-admin`} className="field ltr text-center w-24 shrink-0" inputMode="numeric" maxLength={2}
        placeholder={t("إداري")} value={adm} required={!optional} onChange={(e) => upd(e.target.value.replace(/\D/g, "").slice(0, 2), plate)} />
      <span className="text-2xl text-slate-400">/</span>
      <input data-testid={`${testid}-number`} className="field ltr text-left flex-1 min-w-0" inputMode="numeric"
        placeholder={t("رقم اللوحة")} value={plate} required={!optional} onChange={(e) => upd(adm, e.target.value.replace(/[\s/]/g, ""))} />
    </div>
  );
}
